export const environment = {
  production: false,
  // api_url: 'http://localhost:8080/accounts/',
  api_url: 'https://morning-fortress-66380.herokuapp.com/',
  api_auth_token: 'f13a6a8c20f3726bb2e30112c0614237a4e63cef',
};



// WEBPACK FOOTER //
// ./src/app/environments/environment.ts